export const test = () => 'module test';

const parameters = {
  '1': {length: 1920, onoff: true,  dotted: false, tie: false},
  '2': {length: 960,  onoff: true,  dotted: false, tie: false},
  '3': {length: 480,  onoff: true,  dotted: false, tie: false},
  '4': {length: 240,  onoff: true,  dotted: false, tie: false},

  '5': {length: 1920, onoff: false, dotted: false, tie: false},
  '6': {length: 960,  onoff: false, dotted: false, tie: false},
  '7': {length: 480,  onoff: false, dotted: false, tie: false},
  '8': {length: 240,  onoff: false, dotted: false, tie: false},

  'a': {length: 1920, onoff: true,  dotted: true,  tie: false},
  'b': {length: 960,  onoff: true,  dotted: true,  tie: false},
  'c': {length: 480,  onoff: true,  dotted: true,  tie: false},
  // 'd': {length: 240,  onoff: true,  dotted: true,  tie: false},

  'e': {length: 1920, onoff: false, dotted: true,  tie: false},
  'f': {length: 960,  onoff: false, dotted: true,  tie: false},
  'g': {length: 480,  onoff: false, dotted: true,  tie: false},
  // 'h': {length: 240,  onoff: false, dotted: true,  tie: false},

  'k': {length: 1920, onoff: true,  dotted: false, tie: true},
  'l': {length: 960,  onoff: true,  dotted: false, tie: true},
  'm': {length: 480,  onoff: true,  dotted: false, tie: true},
  'n': {length: 240,  onoff: true,  dotted: false, tie: true},

  'o': {length: 1920, onoff: false, dotted: false, tie: true},
  'p': {length: 960,  onoff: false, dotted: false, tie: true},
  'q': {length: 480,  onoff: false, dotted: false, tie: true},
  'r': {length: 240,  onoff: false, dotted: false, tie: true},

  'A': {length: 1920, onoff: true,  dotted: true, tie: true },
  'B': {length: 960,  onoff: true,  dotted: true, tie: true },
  'C': {length: 480,  onoff: true,  dotted: true, tie: true },
  // 'D': {length: 240,  onoff: true,  dotted: true, tie: true },

  'E': {length: 1920, onoff: false, dotted: true, tie: true },
  'F': {length: 960,  onoff: false, dotted: true, tie: true },
  'G': {length: 480,  onoff: false, dotted: true, tie: true },
  // 'H': {length: 240,  onoff: false, dotted: true, tie: true },

  // triplets
  's': { length: 640, onoff: true, dotted: false, tie: false },
  't': { length: 320, onoff: true, dotted: false, tie: false },
  'u': { length: 160, onoff: true, dotted: false, tie: false },

  'x': { length: 640, onoff: false, dotted: false, tie: false },
  'y': { length: 320, onoff: false, dotted: false, tie: false },
  'z': { length: 160, onoff: false, dotted: false, tie: false },

  '9': { length: 640, onoff: true, dotted: true, tie: false },
  '0': { length: 320, onoff: true, dotted: true, tie: false },

  'd': { length: 640, onoff: false, dotted: true, tie: false },
  'h': { length: 320, onoff: false, dotted: true, tie: false },

  'S': { length: 640, onoff: true, dotted: false, tie: true },
  'T': { length: 320, onoff: true, dotted: false, tie: true },
  'U': { length: 160, onoff: true, dotted: false, tie: true },

  'X': { length: 640, onoff: false, dotted: false, tie: true },
  'Y': { length: 320, onoff: false, dotted: false, tie: true },
  'Z': { length: 160, onoff: false, dotted: false, tie: true },

  'i': { length: 640, onoff: true, dotted: true, tie: true },
  'j': { length: 320, onoff: true, dotted: true, tie: true },

  'D': { length: 640, onoff: false, dotted: true, tie: true },
  'H': { length: 320, onoff: false, dotted: true, tie: true },
}

export const generateURLparam =  score => {
  let result = '';
  for (let note of score) {
    for (let key in parameters) {
      if (parameters[key].length === note.length &&
          parameters[key].onoff === note.onoff &&
          parameters[key].dotted === note.dotted &&
          parameters[key].tie === note.tie) {
        result += key;
      } else {
        continue;
      }
    }
  }
  return result;
}

export const transfferURLparam = params => {
  let result = [];
  for (let param of params) {
    result.push(parameters[param])
  }
  return result;
}
